const convertToCSV = (participants) => {
    if (!participants.length) return "";

    // Exclude unwanted fields
    const excludeFields = ["created_at", "camp_id", "id"];
    const headers = Object.keys(participants[0]).filter(h => !excludeFields.includes(h));

    const csvRows = [];

    // Add header row
    csvRows.push(headers.join(","));

    // Add participant rows
    for (const participant of participants) {
        const values = headers.map(header => {
            const val = participant[header];
            const escaped = ("" + (val ?? "")).replace(/"/g, '""');
            return `"${escaped}"`;
        });
        csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
};
const quoteCSVValue = (value) => {
    if (value == null) return "";
    const str = String(value).replace(/"/g, '""');
    return `"${str}"`;
};
const formatDateGerman = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString("de-DE"); // "DD.MM.YYYY"
};

const formatBoolean = (value) => (value ? "Ja" : "Nein");

const downloadCSV = (participants, selectedCamp, columnConfig = []) => {
    if (!selectedCamp) {
        alert("Kein Camp ausgewählt.");
        return;
    }

    if (!participants || participants.length === 0) {
        alert("Keine Teilnehmerdaten zum Herunterladen.");
        return;
    }

    // Create config map
    const configMap = new Map();
    columnConfig.forEach(col => configMap.set(col.key, col));

    // Get all keys and filter those not excluded
    const allKeys = Object.keys(participants[0]);
    const includedKeys = allKeys.filter((key) => {
        const config = configMap.get(key);
        return !(config?.exclude);
    });

    // Build header row with labels if defined
    const headers = includedKeys.map((key) => {
        const config = configMap.get(key);
        return config?.label || key;
    });

    // Build data rows
    const rows = participants.map((participant) =>
        includedKeys.map((key) => {
            const config = configMap.get(key);
            const rawValue = participant[key];
            const value = config?.format ? config.format(rawValue, participant) : rawValue ?? "";
            return quoteCSVValue(value);
        })
    );

    // Build CSV string
    const csvContent =
        headers.map(quoteCSVValue).join(";") + "\n" +
        rows.map((row) => row.join(";")).join("\n");

    // Optional: Add UTF-8 BOM for Excel compatibility
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });

    // Trigger download
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;

    const safeCampTitle = selectedCamp.title.replace(/\s+/g, "_").toLowerCase();
    link.setAttribute("download", `${safeCampTitle}_participants.csv`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};


export { downloadCSV, formatDateGerman, formatBoolean };
